import { render, staticRenderFns } from "./PaymentsReview.vue?vue&type=template&id=2a539065&scoped=true&"
import script from "./PaymentsReview.vue?vue&type=script&lang=ts&"
export * from "./PaymentsReview.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentsReview.vue?vue&type=style&index=0&id=2a539065&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a539065",
  null
  
)

export default component.exports